// import React from 'react';
// import { Container, Typography, TextField, Button, Grid, Paper, Box, AppBar, Toolbar, IconButton, Menu, MenuItem, Card, CardContent, CardMedia } from '@mui/material';
// import { styled } from '@mui/system';
// import { Menu as MenuIcon } from '@mui/icons-material';
// import { useState } from 'react';

// // Styled components
// const HeroSection = styled('section')({
//   height: '100vh',
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   backgroundImage: 'url(https://via.placeholder.com/1500)',
//   backgroundSize: 'cover',
//   backgroundPosition: 'center',
//   color: 'white',
//   position: 'relative',
//   textAlign: 'center',
// });

// const ContactFormSection = styled('section')({
//   height: '100vh',
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   backgroundColor: '#f5f5f5',
// });

// const FeaturedPropertiesSection = styled('section')({
//   height: '100vh',
//   backgroundColor: '#eaeaea',
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   flexDirection: 'column',
//   padding: '50px 0',
// });

// const FooterSection = styled('section')({
//   height: '80vh',
//   backgroundColor: '#2c3e50',
//   color: 'white',
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   flexDirection: 'column',
//   padding: '40px 0',
// });

// // Navigation Bar
// const Navbar = () => {
//   const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
//   const handleMenu = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
//   const handleClose = () => setAnchorEl(null);

//   return (
//     <AppBar position="sticky">
//       <Toolbar>
//         <Typography variant="h6" sx={{ flexGrow: 1 }}>
//           Real Estate
//         </Typography>
//         <IconButton edge="end" color="inherit" onClick={handleMenu}>
//           <MenuIcon />
//         </IconButton>
//         <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
//           <MenuItem onClick={handleClose}>Home</MenuItem>
//           <MenuItem onClick={handleClose}>Properties</MenuItem>
//           <MenuItem onClick={handleClose}>Contact</MenuItem>
//         </Menu>
//       </Toolbar>
//     </AppBar>
//   );
// };

// // Featured Property Card
// const PropertyCard = ({ image, title, price }: { image: string; title: string; price: string }) => (
//   <Card sx={{ maxWidth: 345, margin: 2, transition: 'transform 0.3s', '&:hover': { transform: 'scale(1.05)' } }}>
//     <CardMedia component="img" height="140" image={image} alt={title} />
//     <CardContent>
//       <Typography variant="h6">{title}</Typography>
//       <Typography variant="body2" color="text.secondary">
//         {price}
//       </Typography>
//     </CardContent>
//   </Card>
// );

// // Component
// const App: React.FC = () => {
//   return (
//     <div>
//       {/* Navbar */}
//       <Navbar />

//       {/* Hero Section */}
//       <HeroSection>
//         <Box textAlign="center" sx={{ zIndex: 1 }}>
//           <Typography variant="h3" gutterBottom>
//             Find Your Dream Home
//           </Typography>
//           <Typography variant="h5" paragraph>
//             Explore a wide range of properties at the best prices.
//           </Typography>
//           <Button variant="contained" color="primary" size="large" href="#contact">
//             Get in Touch
//           </Button>
//         </Box>
//       </HeroSection>

//       {/* Featured Properties Section */}
//       <FeaturedPropertiesSection>
//         <Typography variant="h4" gutterBottom>
//           Featured Properties
//         </Typography>
//         <Grid container spacing={3} justifyContent="center">
//           <Grid item xs={12} sm={6} md={4}>
//             <PropertyCard image="https://via.placeholder.com/350x150" title="Modern Apartment" price="$250,000" />
//           </Grid>
//           <Grid item xs={12} sm={6} md={4}>
//             <PropertyCard image="https://via.placeholder.com/350x150" title="Luxury Villa" price="$1,200,000" />
//           </Grid>
//           <Grid item xs={12} sm={6} md={4}>
//             <PropertyCard image="https://via.placeholder.com/350x150" title="Family Home" price="$450,000" />
//           </Grid>
//         </Grid>
//       </FeaturedPropertiesSection>

//       {/* Contact Form Section */}
//       <ContactFormSection id="contact">
//         <Paper sx={{ padding: 4, borderRadius: 2, boxShadow: 3, width: '100%', maxWidth: 600 }}>
//           <Typography variant="h4" gutterBottom textAlign="center">
//             Contact Us
//           </Typography>
//           <form noValidate autoComplete="off">
//             <Grid container spacing={3} direction="column" alignItems="center">
//               <Grid item xs={12}>
//                 <TextField required id="name" label="Full Name" variant="outlined" fullWidth sx={{ maxWidth: 500 }} />
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   required
//                   id="email"
//                   label="Email"
//                   variant="outlined"
//                   fullWidth
//                   sx={{ maxWidth: 500 }}
//                   type="email"
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   required
//                   id="message"
//                   label="Message"
//                   variant="outlined"
//                   fullWidth
//                   sx={{ maxWidth: 500 }}
//                   multiline
//                   rows={4}
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <Button variant="contained" color="primary" sx={{ marginTop: 2 }} type="submit">
//                   Submit
//                 </Button>
//               </Grid>
//             </Grid>
//           </form>
//         </Paper>
//       </ContactFormSection>

//       {/* Footer Section */}
//       <FooterSection>
//         <Box textAlign="center">
//           <Typography variant="h5" gutterBottom>
//             Get in Touch
//           </Typography>
//           <Grid container justifyContent="center" spacing={3}>
//             <Grid item>
//               <Button variant="text" color="inherit">Facebook</Button>
//             </Grid>
//             <Grid item>
//               <Button variant="text" color="inherit">Twitter</Button>
//             </Grid>
//             <Grid item>
//               <Button variant="text" color="inherit">LinkedIn</Button>
//             </Grid>
//           </Grid>
//           <Typography variant="body2" mt={3}>
//             &copy; {new Date().getFullYear()} Real Estate. All rights reserved. <br />
//             123 Main St, New York, NY
//           </Typography>
//         </Box>
//       </FooterSection>
//     </div>
//   );
// };

// export default App;





import React from 'react';
import ContactUs from './ContactUs';
import HeroBanner from './HeroBanner';
import ContactForm from '../Aboutus/ContactForm';

const ContactUsPage = () => {
    return (
        <>
            <HeroBanner />
            {/* <ContactUs /> */}
            <ContactForm />
        </>
    );
};

export default ContactUsPage;